import { TanStackDevtools } from '@tanstack/react-devtools';
import { FormDevtoolsPanel } from '@tanstack/react-form-devtools';
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';
import {
    getRouteApi,
    RouterContextProvider,
    useRouter,
} from '@tanstack/react-router';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';
import { ReactNode, useEffect } from 'react';
import { ToastContainer, toast as notify } from 'react-toastify';
import Footer from '~/components/Footer';
import Header from '~/components/Header';
import { useAuthData } from '~/components/Providers/AuthContext';
import { setNavigate } from '~/components/Providers/NavigatorService';
import { toastLists } from '~/util/types/toasts';

const Route = getRouteApi('__root__');
export function RootComponent({ children }: Readonly<{ children: ReactNode }>) {
    const navigate = Route.useNavigate();
    const showToast = Route.useSearch({ select: ({ showToast }) => showToast });

    useEffect(() => {
        setNavigate(navigate);
    }, [navigate]);

    useEffect(() => {
        if (!showToast) return;
        const toast = toastLists[showToast];
        if (!toast) return;

        notify(toast.message, { type: toast.type ?? 'info' });

        navigate({
            search: (prev) => ({ ...prev, showToast: undefined }),
            replace: true,
        });
    }, [navigate, showToast]);

    const router = useRouter();
    const auth = useAuthData();
    return (
        <div className="flex min-h-dvh flex-col">
            <div className="mx-2 md:mx-10 mb-4 flex-1">
                <RouterContextProvider router={router} context={{ auth }}>
                    <Header />
                    {children}
                    <TanStackDevtools
                        plugins={[
                            {
                                name: 'TanStack Query',
                                render: <ReactQueryDevtoolsPanel />,
                            },
                            {
                                name: 'TanStack Router',
                                render: <TanStackRouterDevtoolsPanel />,
                            },
                            {
                                name: 'TanStack Form',
                                render: <FormDevtoolsPanel />,
                            },
                        ]}
                    />
                    <ToastContainer theme="dark" position="bottom-right" />
                </RouterContextProvider>
            </div>
            <Footer />
        </div>
    );
}
